module.exports = __webpack_public_path__ + "img/111.0c6e8a1c.jpg";